var Curriculog = Curriculog || {};

Curriculog.ParentListView = (function ($, _, Backbone, ParentListView) {

	ParentListView = Curriculog.CurriculogView.extend({
		template: 'HierarchyList/parentList.html',
		initialize: function (options) {
			this.entity = options.entity;
			this.entities = options.entities;
			this.canDelete = options.canDelete;
			this.relationships = options.relationships;
			this.listenTo(this.relationships, 'add', this.render);
			this.listenTo(this.relationships, 'remove', this.render);
			this.listenTo(this.relationships, 'change', this.render);
			this.render();
		},

		render: function () {
			var parents = [];
			var unsortedParentIDs = this.relationships.getParents(this.entity.id);
			var sortedParents = this.entities.getSortedEntities(unsortedParentIDs);
			for (var i=0; i < sortedParents.length; i++) {
				var parent = sortedParents[i];

				parents.push({
					id: parent.get('id'),
					name: parent.get('name'),
				});
			}

			var templateData = {
				parents: parents,
				canDelete: this.canDelete,
			};
			var el = nunjucks.render(this.template, templateData);
			this.replaceElement(el);
		},
	});
	return ParentListView;

})($, _, Backbone, Curriculog.ParentListView || {});